webpackJsonp([3],{

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stat.vue


/* harmony default export */ var Stat = ({
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a245f3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stat.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-xs-center"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card-text',[(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","height":2}}):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.$slots.actions)?_c('v-card-row',{attrs:{"actions":""}},[_vm._t("actions")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Stat = (esExports);
// CONCATENATED MODULE: ./src/components/Stat.vue
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a245f3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Stat,
  components_Stat,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Stat = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var endpoints = {
    api: null,
    upload: null,
    chat: null,
};
exports.endpoints = endpoints;
var environment = {
    request: null,
    isNode: false,
    cache: {},
};
exports.environment = environment;
var init = function (domain) {
    if (domain === void 0) { domain = "skiliko.com"; }
    if (typeof domain === "string") {
        endpoints.api = "https://api." + domain;
        endpoints.upload = "https://upload.api." + domain;
        endpoints.chat = "https://chat." + domain;
    }
    else {
        endpoints.api = domain.api;
        endpoints.upload = domain.upload;
        endpoints.chat = domain.chat;
    }
};
var initForBrowser = function (domain) {
    environment.isNode = false;
    environment.request = null;
    environment.cache = window["__SKILIKO_CACHE__"] || {};
    init(domain);
};
exports.initForBrowser = initForBrowser;
var initForNode = function (request, domain) {
    environment.isNode = true;
    environment.request = request;
    environment.cache = {};
    init(domain);
};
exports.initForNode = initForNode;
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(871);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__(854);
var Settings = __webpack_require__(846);
var constants_1 = __webpack_require__(755);
var defaultHeader = function () {
    var token = Settings.get("token", {});
    var headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
    };
    if (token.platform_token) {
        headers["PlatformToken"] = token.platform_token;
    }
    if (token.access_token && token.token_type) {
        headers["Authorization"] = [
            token.token_type,
            token.access_token,
        ].join(" ");
    }
    return headers;
};
var extractPagination = function (result) {
    var headerValue = function (key) {
        var value = result.headers[key] || result.headers[key.toLowerCase()];
        return value && parseInt(value, 10);
    };
    if (!headerValue('X-Page')) {
        return null;
    }
    return {
        total: headerValue('X-Total'),
        totalPages: headerValue('X-Total-Pages'),
        page: headerValue('X-Page'),
        perPage: headerValue('X-Per-Page'),
        nextPage: headerValue('X-Next-Page'),
        prevPage: headerValue('X-Prev-Page'),
        offset: headerValue('X-Offset'),
    };
};
var request = function (url, method, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    if (!constants_1.endpoints.api) {
        throw new Error("Skiliko SKD not initialized");
    }
    var config = {
        url: url,
        method: method,
        headers: Object.assign({}, defaultHeader(), headers),
    };
    if (Object.keys(data).length > 0) {
        config[method === "get" ? "params" : "data"] = data;
    }
    return axios_1.default(config)
        .then(function (response) {
        var data = response.data;
        if (!data || !Array.isArray(data)) {
            return data;
        }
        data["pagination"] = extractPagination(response);
        return data;
    });
};
var sendGet = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    var dataToParams = Object.keys(data)
        .map(function (key) { return [key, data[key]].join("="); })
        .join("&");
    if (url.indexOf("?") <= 0) {
        url += "?";
    }
    url += dataToParams;
    return request(url, "get", {}, headers);
};
exports.sendGet = sendGet;
var sendPost = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    return request(url, "post", data, headers);
};
exports.sendPost = sendPost;
var sendPut = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    return request(url, "put", data, headers);
};
exports.sendPut = sendPut;
var sendDelete = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    return request(url, "delete", data, headers);
};
exports.sendDelete = sendDelete;
//# sourceMappingURL=_request-api.js.map

/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("a54c80b0", content, true);

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".card__title[data-v-4a245f3c]{text-align:center}.card__text[data-v-4a245f3c],.card__title[data-v-4a245f3c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card__text[data-v-4a245f3c]{font-size:3em;padding-top:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.progress-circular[data-v-4a245f3c]{position:absolute;top:.25em;right:.25em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/Stat.vue"],"names":[],"mappings":"AACA,8BACE,iBAAmB,CAIpB,AACD,2DAJE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAcjC,AAZD,6BACE,cAAe,AACf,cAAe,AAIf,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACE,kBAAmB,AACnB,UAAW,AACX,WAAa,CACd","file":"Stat.vue","sourcesContent":["\n.card__title[data-v-4a245f3c] {\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.card__text[data-v-4a245f3c] {\n  font-size: 3em;\n  padding-top: 0;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.progress-circular[data-v-4a245f3c] {\n  position: absolute;\n  top: .25em;\n  right: .25em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(755);
var STORATE_KEY = "settings";
var LocalStorageStore = (function () {
    function LocalStorageStore() {
    }
    LocalStorageStore.prototype.getItem = function (key) { return localStorage.getItem(key); };
    LocalStorageStore.prototype.setItem = function (key, value) { localStorage.setItem(key, value); };
    return LocalStorageStore;
}());
var CacheStorage = (function () {
    function CacheStorage() {
    }
    CacheStorage.prototype.getItem = function (key) { return constants_1.environment.cache[key]; };
    CacheStorage.prototype.setItem = function (key, value) {
        return constants_1.environment.cache = __assign({}, constants_1.environment.cache, (_a = {}, _a[key] = value, _a));
        var _a;
    };
    return CacheStorage;
}());
var createStore = function () {
    if (typeof localStorage === "undefined") {
        return new CacheStorage();
    }
    else {
        return new LocalStorageStore();
    }
};
var store = createStore();
var storage = function () { return JSON.parse(store.getItem(STORATE_KEY) || "{}") || {}; };
var save = function (data) { return store.setItem(STORATE_KEY, JSON.stringify(data)); };
var get = function (key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return storage()[key] || defaultValue || null;
};
exports.get = get;
var set = function (key, value) {
    var newStorage = storage();
    newStorage[key] = value;
    save(newStorage);
    return value;
};
exports.set = set;
var remove = function (key) {
    var newStorage = storage();
    delete newStorage[key];
    save(newStorage);
};
exports.remove = remove;
//# sourceMappingURL=settings.js.map

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateFromJson = function (value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    if (parseInt(value, 10).toString() === value && value.length === 8) {
        var year = parseInt(value.substring(0, 4), 10);
        var month = parseInt(value.substring(4, 6), 10) - 1;
        var day = parseInt(value.substring(6), 10);
        return new Date(year, month, day);
    }
    return new Date(value);
};
exports.DateFromJson = DateFromJson;
//# sourceMappingURL=date-from-json.js.map

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(887);

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(761);
var normalizeHeaderName = __webpack_require__(889);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(872);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(872);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var Settings = __webpack_require__(846);
var constants_1 = __webpack_require__(755);
var signedInCallbacks = [];
var signedOutCallbacks = [];
var pingInterval = 5 * 60 * 1000;
var pingId;
var sessionStarted = false;
var ping = function () {
    return Request
        .sendPost(constants_1.endpoints.api + "/user/ping");
};
var updateCallback = function (list, callback) {
    var index = list
        .map(function (f) { return f.toString(); })
        .indexOf(callback.toString());
    if (index < 0) {
        list.push(callback);
    }
    else {
        list[index] = callback;
    }
    return callback;
};
var whenLogin = function (token) {
    Settings.set("token", token);
    signedInCallbacks.forEach(function (callback) {
        if (callback && sessionStarted) {
            callback(token);
        }
    });
    return token;
};
var whenLogout = function (platformToken) {
    if (platformToken === void 0) { platformToken = null; }
    Settings.set("token", {
        platform_token: (Settings.get("token") || {}).platform_token || platformToken,
    });
    signedOutCallbacks.forEach(function (callback) {
        if (callback && sessionStarted) {
            callback();
        }
    });
    return;
};
var signedIn = function () {
    var token = Settings.get("token");
    if (!token) {
        return false;
    }
    if (!token.access_token) {
        return false;
    }
    if (!token.expires_in) {
        return true;
    }
    var expire = token.created_at + token.expires_in;
    var now = (new Date()).getTime() / 1000;
    return expire > now;
};
exports.signedIn = signedIn;
var login = function (email, password, scope, platformName) {
    if (scope === void 0) { scope = "user"; }
    if (platformName === void 0) { platformName = null; }
    var headers = scope === "admin" ? { PlatformTokenName: platformName } : {};
    return Request
        .sendPost(constants_1.endpoints.api + "/oauth/token", {
        grant_type: "password",
        username: email,
        password: password,
        scope: scope,
    }, headers)
        .then(whenLogin);
};
exports.login = login;
var logout = function () {
    var token = Settings.get("token") || {};
    var accessToken = (Settings.get("token") || {}).access_token;
    return (token.access_token
        ? Request.sendPost(constants_1.endpoints.api + "/oauth/revoke", { token: accessToken })
        : Promise.resolve())
        .then(whenLogout);
};
exports.logout = logout;
var register = function (params) {
    return Request
        .sendPost(constants_1.endpoints.api + "/users", params)
        .then(whenLogin);
};
exports.register = register;
var unregister = function () {
    return Request
        .sendDelete(constants_1.endpoints.api + "/user")
        .then(whenLogout);
};
exports.unregister = unregister;
var onSignedIn = function (callback) {
    updateCallback(signedInCallbacks, callback);
    if (signedIn() && callback && sessionStarted) {
        setTimeout(callback);
    }
};
exports.onSignedIn = onSignedIn;
var onSignedOut = function (callback) {
    updateCallback(signedOutCallbacks, callback);
    if (!signedIn() && callback && sessionStarted) {
        setTimeout(callback);
    }
};
exports.onSignedOut = onSignedOut;
var init = function (platformToken) {
    sessionStarted = true;
    if (signedIn()) {
        whenLogin(Settings.get("token", {
            platform_token: platformToken,
        }));
    }
    else {
        whenLogout(platformToken);
    }
};
exports.init = init;
onSignedIn(function () {
    ping();
    pingId = pingId || setInterval(function () {
        if (!pingId) {
            return;
        }
        ping();
    }, pingInterval);
});
onSignedOut(function () {
    if (!pingId) {
        return;
    }
    clearInterval(pingId);
    pingId = null;
});
//# sourceMappingURL=session.js.map

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var Settings = __webpack_require__(846);
var constants_1 = __webpack_require__(755);
var platformToken = function () {
    return Settings.get("token", {}).platform_token;
};
var current = function () {
    if (constants_1.environment.cache["platformPromise"]) {
        return constants_1.environment.cache["platformPromise"];
    }
    if (constants_1.environment.cache["platform"]) {
        constants_1.environment.cache["platformPromise"] = Promise.resolve(constants_1.environment.cache["platform"]);
    }
    else {
        constants_1.environment.cache["platformPromise"] = Request
            .sendGet(constants_1.endpoints.api + "/platform", {}, (constants_1.environment["request"] || {})["headers"]);
    }
    return constants_1.environment.cache["platformPromise"]
        .then(function (p) {
        if (p) {
            constants_1.environment.cache["platform"] = p;
            Settings.set("locale", p["locale"]);
            Settings.set("token", Object.assign({}, Settings.get("token"), {
                platform_token: p["token"]
            }));
        }
        return p;
    });
};
exports.current = current;
var update = function (data) {
    return Request
        .sendPut(constants_1.endpoints.api + "/platform/" + platformToken(), data)
        .then(function (p) {
        constants_1.environment.cache["platform"] = p;
        return p;
    });
};
exports.update = update;
var updateSettings = function (data) {
    return update({ settings: JSON.stringify(data) });
};
exports.updateSettings = updateSettings;
var currency = function () {
    return (constants_1.environment.cache["platform"] || {}).currency;
};
exports.currency = currency;
//# sourceMappingURL=platform.js.map

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var helpers = __webpack_require__(878);
exports.helpers = helpers;
var data_1 = __webpack_require__(884);
exports.initForBrowser = data_1.initForBrowser;
exports.initForNode = data_1.initForNode;
__export(__webpack_require__(885));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var date_from_json_1 = __webpack_require__(853);
var DateToInput = function (value) {
    if (!value) {
        return null;
    }
    try {
        return date_from_json_1.DateFromJson(value).toISOString().substring(0, 10);
    }
    catch (_) {
        return null;
    }
};
exports.DateToInput = DateToInput;
//# sourceMappingURL=date-to-input.js.map

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimezoneData = [
    { name: "American Samoa", offset: -660 }, { name: "International Date Line West", offset: -660 },
    { name: "Midway Island", offset: -660 },
    { name: "Hawaii", offset: -600 },
    { name: "Alaska", offset: -540 },
    { name: "Pacific Time (US & Canada)", offset: -480 }, { name: "Tijuana", offset: -480 },
    { name: "Arizona", offset: -420 }, { name: "Chihuahua", offset: -420 },
    { name: "Mazatlan", offset: -420 }, { name: "Mountain Time (US & Canada)", offset: -420 },
    { name: "Central America", offset: -360 },
    { name: "Central Time (US & Canada)", offset: -360 }, { name: "Guadalajara", offset: -360 },
    { name: "Mexico City", offset: -360 }, { name: "Monterrey", offset: -360 },
    { name: "Saskatchewan", offset: -360 },
    { name: "Bogota", offset: -300 }, { name: "Eastern Time (US & Canada)", offset: -300 },
    { name: "Indiana (East)", offset: -300 }, { name: "Lima", offset: -300 },
    { name: "Quito", offset: -300 },
    { name: "Atlantic Time (Canada)", offset: -240 }, { name: "Caracas", offset: -240 },
    { name: "Georgetown", offset: -240 }, { name: "La Paz", offset: -240 },
    { name: "Santiago", offset: -240 },
    { name: "Newfoundland", offset: -210 },
    { name: "Brasilia", offset: -180 }, { name: "Buenos Aires", offset: -180 },
    { name: "Greenland", offset: -180 }, { name: "Montevideo", offset: -180 },
    { name: "Mid-Atlantic", offset: -120 },
    { name: "Azores", offset: -60 }, { name: "Cape Verde Is.", offset: -60 },
    { name: "Casablanca", offset: 0 }, { name: "Dublin", offset: 0 },
    { name: "Edinburgh", offset: 0 }, { name: "Lisbon", offset: 0 }, { name: "London", offset: 0 },
    { name: "Monrovia", offset: 0 }, { name: "UTC", offset: 0 },
    { name: "Amsterdam", offset: 60 },
    { name: "Belgrade", offset: 60 }, { name: "Berlin", offset: 60 }, { name: "Bern", offset: 60 },
    { name: "Bratislava", offset: 60 }, { name: "Brussels", offset: 60 },
    { name: "Budapest", offset: 60 }, { name: "Copenhagen", offset: 60 },
    { name: "Ljubljana", offset: 60 }, { name: "Madrid", offset: 60 }, { name: "Paris", offset: 60 },
    { name: "Prague", offset: 60 }, { name: "Rome", offset: 60 }, { name: "Sarajevo", offset: 60 },
    { name: "Skopje", offset: 60 }, { name: "Stockholm", offset: 60 }, { name: "Vienna", offset: 60 },
    { name: "Warsaw", offset: 60 }, { name: "West Central Africa", offset: 60 },
    { name: "Zagreb", offset: 60 },
    { name: "Athens", offset: 120 }, { name: "Bucharest", offset: 120 },
    { name: "Cairo", offset: 120 }, { name: "Harare", offset: 120 },
    { name: "Helsinki", offset: 120 }, { name: "Istanbul", offset: 120 },
    { name: "Jerusalem", offset: 120 }, { name: "Kyiv", offset: 120 },
    { name: "Pretoria", offset: 120 }, { name: "Riga", offset: 120 }, { name: "Sofia", offset: 120 },
    { name: "Tallinn", offset: 120 }, { name: "Vilnius", offset: 120 },
    { name: "Baghdad", offset: 180 }, { name: "Kuwait", offset: 180 }, { name: "Minsk", offset: 180 },
    { name: "Moscow", offset: 180 }, { name: "Nairobi", offset: 180 },
    { name: "Riyadh", offset: 180 }, { name: "St. Petersburg", offset: 180 },
    { name: "Volgograd", offset: 180 },
    { name: "Tehran", offset: 210 },
    { name: "Abu Dhabi", offset: 240 }, { name: "Baku", offset: 240 },
    { name: "Muscat", offset: 240 }, { name: "Tbilisi", offset: 240 },
    { name: "Yerevan", offset: 240 },
    { name: "Kabul", offset: 270 },
    { name: "Ekaterinburg", offset: 300 }, { name: "Islamabad", offset: 300 },
    { name: "Karachi", offset: 300 }, { name: "Tashkent", offset: 300 },
    { name: "Chennai", offset: 330 }, { name: "Kolkata", offset: 330 },
    { name: "Mumbai", offset: 330 }, { name: "New Delhi", offset: 330 },
    { name: "Sri Jayawardenepura", offset: 330 },
    { name: "Kathmandu", offset: 345 },
    { name: "Almaty", offset: 360 }, { name: "Astana", offset: 360 }, { name: "Dhaka", offset: 360 },
    { name: "Urumqi", offset: 360 },
    { name: "Rangoon", offset: 390 },
    { name: "Bangkok", offset: 420 }, { name: "Hanoi", offset: 420 },
    { name: "Jakarta", offset: 420 }, { name: "Krasnoyarsk", offset: 420 },
    { name: "Novosibirsk", offset: 420 },
    { name: "Beijing", offset: 480 }, { name: "Chongqing", offset: 480 },
    { name: "Hong Kong", offset: 480 }, { name: "Irkutsk", offset: 480 },
    { name: "Kuala Lumpur", offset: 480 }, { name: "Perth", offset: 480 },
    { name: "Singapore", offset: 480 }, { name: "Taipei", offset: 480 },
    { name: "Ulaanbaatar", offset: 480 },
    { name: "Osaka", offset: 540 }, { name: "Sapporo", offset: 540 }, { name: "Seoul", offset: 540 },
    { name: "Tokyo", offset: 540 }, { name: "Yakutsk", offset: 540 },
    { name: "Adelaide", offset: 570 }, { name: "Darwin", offset: 570 },
    { name: "Brisbane", offset: 600 }, { name: "Canberra", offset: 600 },
    { name: "Guam", offset: 600 }, { name: "Hobart", offset: 600 },
    { name: "Melbourne", offset: 600 }, { name: "Port Moresby", offset: 600 },
    { name: "Sydney", offset: 600 }, { name: "Vladivostok", offset: 600 },
    { name: "Magadan", offset: 660 }, { name: "New Caledonia", offset: 660 },
    { name: "Solomon Is.", offset: 660 },
    { name: "Auckland", offset: 720 }, { name: "Fiji", offset: 720 },
    { name: "Kamchatka", offset: 720 }, { name: "Marshall Is.", offset: 720 },
    { name: "Wellington", offset: 720 },
    { name: "Chatham Is.", offset: 765 },
    { name: "Nuku\"alofa", offset: 780 }, { name: "Samoa", offset: 780 },
    { name: "Tokelau Is.", offset: 780 },
];
exports.TimezoneData = TimezoneData;
//# sourceMappingURL=timezones.js.map

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);
var settle = __webpack_require__(890);
var buildURL = __webpack_require__(892);
var parseHeaders = __webpack_require__(893);
var isURLSameOrigin = __webpack_require__(894);
var createError = __webpack_require__(873);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(895);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(896);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(891);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var timezones_1 = __webpack_require__(870);
var getTimeZone = function (name) {
    return timezones_1.TimezoneData.find(function (timezone) { return timezone.name === name; });
};
var timeInCurrentZone = function (day, hour, minute, timezone, timezoneOffset) {
    var offset = timezoneOffset || getTimeZone(timezone).offset;
    var curr = new Date();
    var date = new Date(curr.getFullYear(), curr.getMonth(), curr.getDate());
    var dayToAdd = ((day - date.getDay()) + 7) % 7;
    var minutesToAdd = 0
        + dayToAdd * 24 * 60
        + hour * 60
        + minute
        - (date.getTimezoneOffset() + offset);
    date.setTime(date.getTime() + minutesToAdd * 60 * 1000);
    return date;
};
var hourString = function (hours, minutes) {
    return [
        ("0" + hours.toString()).slice(-2),
        ("0" + minutes.toString()).slice(-2)
    ].join(":");
};
var offsetToHourString = function (offset) {
    var hoursWithSign = Math.trunc(offset / 60);
    var hours = Math.abs(hoursWithSign);
    var negative = hoursWithSign < 0;
    var minutes = offset % 60;
    return [
        negative ? "-" : "+",
        hourString(hours, minutes),
    ].join("");
};
var detect = function () {
    var offset = -(new Date()).getTimezoneOffset();
    return timezones_1.TimezoneData.find(function (timezone) { return timezone.offset === offset; });
};
exports.detect = detect;
var getSelectOptions = function () {
    timezones_1.TimezoneData.map(function (timezone) { return ({
        label: "(GMT" + offsetToHourString(timezone.offset) + ") " + timezone.name,
        value: timezone.name,
    }); });
};
exports.getSelectOptions = getSelectOptions;
var scheduleToCurrentDates = function (schedule, timezone, timezoneOffset) {
    var days = [[], [], [], [], [], [], []];
    schedule
        .filter(function (s) { return s.from || s.to; })
        .forEach(function (s) {
        if (s.from || s.to) {
            var _a = (s.from || "00:00").split(":").map(function (e) { return parseInt(e, 10); }), fHour = _a[0], fMin = _a[1];
            var _b = (s.to || "24:00").split(":").map(function (e) { return parseInt(e, 10); }), tHour = _b[0], tMin = _b[1];
            var from = timeInCurrentZone(s.day, fHour, fMin, timezone, timezoneOffset);
            var to = timeInCurrentZone(s.day, tHour, tMin, timezone, timezoneOffset);
            if (from.getDay() === to.getDay()) {
                days[from.getDay()].push({
                    from: from,
                    to: to,
                });
            }
            else {
                var newTo = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 24, 0);
                var newFrom = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 0, 0);
                if (from.getTime() !== newTo.getTime()) {
                    days[from.getDay()].push({
                        from: from,
                        to: newTo,
                    });
                }
                if (newFrom.getTime() !== to.getTime()) {
                    days[to.getDay()].push({
                        from: newFrom,
                        to: to,
                    });
                }
            }
        }
    });
    return days.map(function (day) { return day.sort(function (a, b) { return a.from - b.from; }); });
};
exports.scheduleToCurrentDates = scheduleToCurrentDates;
//# sourceMappingURL=timezone.js.map

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var date_to_input_1 = __webpack_require__(869);
var Session = __webpack_require__(856);
var Request = __webpack_require__(762);
var constants_1 = __webpack_require__(755);
var user = null;
var promise = null;
var updateUser = function (userData) {
    if (!userData["birthday"]) {
        return userData;
    }
    return Object.assign({}, userData, {
        birthday: date_to_input_1.DateToInput(userData["birthday"] * 1000)
    });
};
var current = function (options) {
    if (options === void 0) { options = {}; }
    if (options["forceFetch"]) {
        user = promise = null;
    }
    if (user) {
        return Promise.resolve(user);
    }
    if (promise) {
        return promise;
    }
    promise = Request.sendGet(constants_1.endpoints.api + "/user")
        .then(updateUser);
    return promise;
};
exports.current = current;
var save = function (data) {
    if (data["birthday"] && parseInt(data["birthday"], 10) !== data["birthday"]) {
        data["birthday"] = +new Date(data["birthday"]) / 1000;
    }
    return Request.sendPut(constants_1.endpoints.api + "/user", data)
        .then(updateUser);
};
exports.save = save;
var updateWith = function (data) {
    if (!user) {
        return;
    }
    updateUser(Object.assign({}, user, data));
};
exports.updateWith = updateWith;
Session.onSignedOut(function () {
    user = promise = null;
});
//# sourceMappingURL=user.js.map

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(879));
__export(__webpack_require__(853));
__export(__webpack_require__(869));
__export(__webpack_require__(880));
__export(__webpack_require__(881));
__export(__webpack_require__(882));
__export(__webpack_require__(883));
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CardValidator = function (number) {
    var nCheck = 0;
    var nDigit = 0;
    var bEven = false;
    var value = number.replace(/\D/g, "");
    for (var n = value.length - 1; n >= 0; n--) {
        nDigit = parseInt(value.charAt(n), 10);
        if (bEven) {
            nDigit *= 2;
            if (nDigit > 9)
                nDigit -= 9;
        }
        nCheck += nDigit;
        bEven = !bEven;
    }
    return nCheck % 10 === 0;
};
exports.CardValidator = CardValidator;
//# sourceMappingURL=card-validator.js.map

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var date_from_json_1 = __webpack_require__(853);
var DatetimeToInput = function (datetime) {
    try {
        var date = date_from_json_1.DateFromJson(datetime);
        var offset = date.getTimezoneOffset();
        return (new Date(+date - offset * 60 * 1000))
            .toISOString()
            .substring(0, 16);
    }
    catch (e) {
        return null;
    }
};
exports.DatetimeToInput = DatetimeToInput;
//# sourceMappingURL=datetime-to-input.js.map

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var currencies = {
    EUR: "€",
    USD: "$",
    GBP: "£",
    CHF: "CHF",
};
var FormatPrice = function (value, currency) {
    if (currency === void 0) { currency = "EUR"; }
    if (!value) {
        return "-";
    }
    return [
        (value / 100).toFixed(2),
        currencies[currency],
    ].join("");
};
exports.FormatPrice = FormatPrice;
//# sourceMappingURL=format-price.js.map

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Newline = function (text) {
    return text.replace(/(?:\r\n|\r|\n)/g, "<br />");
};
exports.Newline = Newline;
//# sourceMappingURL=newline.js.map

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SecondsToMinutes = function (time) {
    var t = time;
    var minutes = Math.floor(t / 60);
    t -= minutes * 60;
    var seconds = parseInt((t % 60).toString(), 10);
    var secondsStr = seconds < 10 ? "0" + seconds : seconds.toString();
    return minutes + "m" + secondsStr + "s";
};
exports.SecondsToMinutes = SecondsToMinutes;
//# sourceMappingURL=seconds-to-minutes.js.map

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(755));
__export(__webpack_require__(870));
//# sourceMappingURL=data.js.map

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Card = __webpack_require__(886);
exports.Card = Card;
var Chat = __webpack_require__(904);
exports.Chat = Chat;
var Country = __webpack_require__(906);
exports.Country = Country;
var Expert = __webpack_require__(907);
exports.Expert = Expert;
var Offer = __webpack_require__(908);
exports.Offer = Offer;
var Password = __webpack_require__(909);
exports.Password = Password;
var Platform = __webpack_require__(857);
exports.Platform = Platform;
var Purchase = __webpack_require__(910);
exports.Purchase = Purchase;
var Rating = __webpack_require__(911);
exports.Rating = Rating;
var Session = __webpack_require__(856);
exports.Session = Session;
var Settings = __webpack_require__(846);
exports.Settings = Settings;
var Support = __webpack_require__(912);
exports.Support = Support;
var Timezone = __webpack_require__(876);
exports.Timezone = Timezone;
var Upload = __webpack_require__(913);
exports.Upload = Upload;
var User = __webpack_require__(877);
exports.User = User;
//# sourceMappingURL=modules.js.map

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__(854);
var Request = __webpack_require__(762);
var constants_1 = __webpack_require__(755);
var preregister = function () {
    return Request.sendPost(constants_1.endpoints.api + "/preregistered_cards");
};
var tokenize = function (cardNumber, cardMonth, cardYear, cardCvx, data) {
    var headers = {
        "Content-Type": "text/plain",
    };
    var params = {
        data: data.preregistration_data,
        accessKeyRef: data.access_key,
        cardNumber: cardNumber,
        cardCvx: cardCvx,
        cardExpirationDate: [
            cardMonth,
            cardYear,
        ].join(""),
    };
    return axios_1.default({
        url: data.card_registration_url,
        method: "POST",
        headers: headers,
        data: Object.keys(params).map(function (k) { return [k, params[k]].join("="); }).join("&"),
    }).then(function (response) { return response.data; });
};
var finalize = function (preregisteredCard, token) {
    return Request.sendPut(constants_1.endpoints.api + "/cards/" + preregisteredCard.id, {
        registration_data: token,
    });
};
var create = function (cardNumber, month, year, cvx) {
    return preregister()
        .then(function (preregisteredCard) {
        return tokenize(cardNumber, month, year, cvx, preregisteredCard)
            .then(function (token) { return finalize(preregisteredCard, token); });
    });
};
exports.create = create;
//# sourceMappingURL=card.js.map

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);
var bind = __webpack_require__(871);
var Axios = __webpack_require__(888);
var defaults = __webpack_require__(855);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(875);
axios.CancelToken = __webpack_require__(902);
axios.isCancel = __webpack_require__(874);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(903);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(855);
var utils = __webpack_require__(761);
var InterceptorManager = __webpack_require__(897);
var dispatchRequest = __webpack_require__(898);
var isAbsoluteURL = __webpack_require__(900);
var combineURLs = __webpack_require__(901);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(873);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);
var transformData = __webpack_require__(899);
var isCancel = __webpack_require__(874);
var defaults = __webpack_require__(855);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(761);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(875);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var socketIO = __webpack_require__(369);
var Request = __webpack_require__(762);
var Session = __webpack_require__(856);
var constants_1 = __webpack_require__(755);
var call_status_1 = __webpack_require__(905);
var chatServers = [];
var signInRequiredError = new Error("Signin required");
var ChatServer = (function () {
    function ChatServer(socket, from) {
        this.socket = socket;
        this.from = from;
    }
    ChatServer.prototype.onNewMessage = function (callback) {
        return this.connect("messages:created", callback);
    };
    ChatServer.prototype.onMessageRead = function (callback) {
        return this.connect("messages:read", callback);
    };
    ChatServer.prototype.onMessageReceived = function (callback) {
        return this.connect("messages:received", callback);
    };
    ChatServer.prototype.onMessageUpdate = function (callback) {
        return this.connect("messages:updated", callback);
    };
    ChatServer.prototype.onNewConversation = function (callback) {
        var _this = this;
        return this.connect("conversations:update", function (conversation) { return callback(Object.assign({}, conversation, {
            with: conversation.from._id === _this.from ? conversation.to : conversation.from
        })); });
    };
    ChatServer.prototype.onCallUpdate = function (callback) {
        return this.connect("call:updated", function (call) { return callback(call_status_1.CallWithStatus(call)); });
    };
    ChatServer.prototype.markAsReceived = function (id) {
        return Request.sendPut(constants_1.endpoints.chat + "/messages/" + id, {
            user: this.from,
            receivedAt: new Date(),
        });
    };
    ChatServer.prototype.markAsRead = function (ids) {
        return Request.sendPost(constants_1.endpoints.chat + "/read", {
            ids: ids,
            user: this.from,
            readAt: new Date(),
        });
    };
    ChatServer.prototype.send = function (message, to, data) {
        if (data === void 0) { data = null; }
        if (!message || message.trim() === "") {
            return Promise.reject({ message: "empty" });
        }
        if (!to) {
            return Promise.reject({ to: "empty" });
        }
        return Request.sendPost(constants_1.endpoints.chat + "/messages", {
            from: this.from,
            to: to,
            content: message,
            sentAt: new Date(),
            data: JSON.stringify(data)
        });
    };
    ChatServer.prototype.conversations = function (page) {
        var _this = this;
        if (page === void 0) { page = 1; }
        return Request.sendGet(constants_1.endpoints.chat + "/users/" + this.from + "/conversations", {
            page: page,
        })
            .then(function (conversations) { return conversations.map(function (conversation) { return Object.assign({}, conversation, {
            with: conversation.from._id === _this.from ? conversation.to : conversation.from
        }); }); });
    };
    ChatServer.prototype.messages = function (conversationId, page) {
        if (page === void 0) { page = 1; }
        if (!conversationId) {
            return Promise.resolve([]);
        }
        return Request.sendGet(constants_1.endpoints.chat + "/conversations/" + conversationId + "/messages", {
            page: page,
        });
    };
    ;
    ChatServer.prototype.conversation = function () {
        console.warn("this method is deprecated, please use conversationWith instead");
        return Request.sendPost(constants_1.endpoints.chat + "/conversations/search", {
            userId: this.from,
        });
    };
    ;
    ChatServer.prototype.conversationWith = function (userId) {
        var _this = this;
        return Request.sendPost(constants_1.endpoints.chat + "/conversations/search", {
            from: userId,
            to: this.from
        })
            .then(function (conversation) { return Object.assign({}, conversation, {
            with: conversation.from._id === _this.from ? conversation.to : conversation.from
        }); })
            .catch(function () { return ({
            from: { _id: _this.from },
            to: { _id: userId },
            with: { _id: userId }
        }); });
    };
    ;
    ChatServer.prototype.connect = function (eventName, callback) {
        this.socket.on(eventName, callback);
        return this;
    };
    return ChatServer;
}());
exports.ChatServer = ChatServer;
var getChat = function (from) {
    if (!Session.signedIn()) {
        throw signInRequiredError;
    }
    return new Promise(function (resolve, reject) {
        var chatServer = chatServers.find(function (e) { return e.from === from; });
        if (chatServer) {
            return resolve(chatServer);
        }
        var socket = socketIO(constants_1.endpoints.chat, {
            transports: ["websocket"],
            query: [
                "user",
                from,
            ].join("="),
        });
        socket.on("disconnect", function () {
            var index = chatServers.findIndex(function (e) { return e.from === from; });
            if (index >= 0) {
                delete chatServers[index];
                chatServers.splice(index, 1);
            }
        });
        socket.on("connect", function () {
            var chatServer = new ChatServer(socket, from);
            chatServers.push(chatServer);
            resolve(chatServer);
        });
        socket.on("error", reject);
        return socket;
    });
};
exports.getChat = getChat;
var pendingMessages = function (user) {
    return Request.sendGet(constants_1.endpoints.chat + "/pendings", {
        user: user,
    });
};
exports.pendingMessages = pendingMessages;
//# sourceMappingURL=chat.js.map

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var statusNames = [
    "queued",
    "ringing",
    "in-progress",
    "canceled",
    "completed",
    "busy",
    "failed",
    "no-answer",
];
var is = function (status, list) {
    var index = statusNames.indexOf(status);
    var indexMax = list
        .map(function (e) { return statusNames.indexOf(e); })
        .sort(function (a, b) { return b - a; })[0];
    return indexMax && indexMax >= index;
};
var CallWithStatus = function (call) {
    var expertStatus = (call["callData"]["caller_states"] || []).map(function (e) { return e["state"]; });
    var userStatus = (call["callData"]["callee_states"] || []).map(function (e) { return e["state"]; });
    var status = [
        { key: "callingExpert", value: is("ringing", expertStatus) },
        { key: "expertAnswering", value: is("in-progress", expertStatus) },
        { key: "callingUser", value: is("ringing", userStatus) },
        { key: "userAnswering", value: is("in-progress", userStatus) },
        { key: "finished", value: is("completed", userStatus) },
    ];
    return Object.assign({}, call, {
        status: (status.filter(function (e) { return e.value; })
            .reverse()[0] || { key: "pending" }).key,
        statusList: status,
    });
};
exports.CallWithStatus = CallWithStatus;
//# sourceMappingURL=call-status.js.map

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__(854);
var Settings = __webpack_require__(846);
var base = "https://skiliko.firebaseio.com/translations";
var path = "collection/countries.json";
var sort = function (countries) {
    var transform = function (code) {
        return { code: code, name: countries[code] };
    };
    return Object.keys(countries)
        .map(transform)
        .sort(function (c1, c2) { return c1.name.localeCompare(c2.name); });
};
var all = function (locale) {
    var url = [
        base,
        locale || Settings.get("locale") || "en",
        path,
    ].join("/");
    return axios_1.default(url)
        .then(function (response) { return response.data; })
        .then(function (countries) { return sort(countries); });
};
exports.all = all;
var codes = function (locale) {
    return all(locale)
        .then(function (countries) { return countries.map(function (e) { return e.code; }); });
};
exports.codes = codes;
//# sourceMappingURL=country.js.map

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var constants_1 = __webpack_require__(755);
var Schedule = __webpack_require__(876);
var localSchedule = function (expert) { return Schedule.scheduleToCurrentDates(expert.schedule, expert.timezone, expert.timezone_offset); };
var todaySchedule = function (expert) { return localSchedule(expert)[(new Date()).getDay()]
    .find(function (d) { return d["from"] < new Date() && d["to"] > new Date(); }); };
exports.todaySchedule = todaySchedule;
var nextSchedule = function (expert) { return localSchedule(expert)
    .reduce(function (a, b) { return a.concat(b); })
    .sort(function (a, b) { return a["from"] - b["from"]; })
    .find(function (e) { return e["from"] > new Date(); }); };
exports.nextSchedule = nextSchedule;
var available = function (expert) {
    if (expert.current_pause) {
        return false;
    }
    if (expert.last_active_call) {
        return false;
    }
    var today = localSchedule(expert)[(new Date()).getDay()];
    if (!today) {
        return false;
    }
    return !!today.find(function (d) { return d["from"] < new Date() && d["to"] > new Date(); });
};
exports.available = available;
var isRestricted = function (expert) { return expert.role === "restricted"; };
exports.isRestricted = isRestricted;
var deprecate = function (method, result) {
    console.warn("[DEPRECATED] expert." + method + "() is now deprecated, use Expert." + method + "(expert) instead");
    return result;
};
var processExpert = function (expert) { return Object.assign({}, expert, {
    localSchedule: localSchedule(expert),
    todaySchedule: function () { return deprecate("todaySchedule", todaySchedule(expert)); },
    nextSchedule: function () { return deprecate("nextSchedule", nextSchedule(expert)); },
    available: function () { return deprecate("available", available(expert)); },
    isRestricted: function () { return deprecate("isRestricted", isRestricted(expert)); },
}); };
var all = function (page) {
    if (page === void 0) { page = 1; }
    return Request.sendGet(constants_1.endpoints.api + "/experts")
        .then(function (experts) { return experts.map(processExpert); });
};
exports.all = all;
var get = function (id) {
    return Request.sendGet(constants_1.endpoints.api + "/experts/" + id)
        .then(processExpert);
};
exports.get = get;
//# sourceMappingURL=expert.js.map

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var Platform = __webpack_require__(857);
var constants_1 = __webpack_require__(755);
var filter = function (condition) {
    return Platform.current()
        .then(function (platform) {
        if (!platform) {
            return [];
        }
        return platform["offers"]
            .filter(condition);
    });
};
var all = function (type) {
    return filter(function (e) { return e["service_type"] === type; });
};
exports.all = all;
var prepaidMinutes = function () {
    return all("prepaid_minute");
};
exports.prepaidMinutes = prepaidMinutes;
var phone = function () {
    return all("phone")
        .then(function (offers) { return offers[0]; });
};
exports.phone = phone;
var promotions = function () {
    return filter(function (e) { return e["promotion"]; });
};
exports.promotions = promotions;
var customOffers = function () {
    return Platform.current()
        .then(function (platform) {
        if (!platform.settings.custom_offers) {
            return [];
        }
        return Request.sendGet(constants_1.endpoints.api + "/custom_offers");
    });
};
exports.customOffers = customOffers;
var get = function (id) {
    return Request.sendGet(constants_1.endpoints.api + "/offers/" + id);
};
exports.get = get;
//# sourceMappingURL=offer.js.map

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var constants_1 = __webpack_require__(755);
var sendInstructions = function (email, resource) {
    if (resource === void 0) { resource = 'User'; }
    return Request.sendPost(constants_1.endpoints.api + "/passwords", {
        email: email,
        resource_type: resource,
    });
};
exports.sendInstructions = sendInstructions;
var reset = function (token, password, confirmation, resource) {
    if (resource === void 0) { resource = 'User'; }
    return Request.sendPut(constants_1.endpoints.api + "/passwords", {
        reset_password_token: token,
        password: password,
        password_confirmation: confirmation,
        resource_type: resource,
    });
};
exports.reset = reset;
//# sourceMappingURL=password.js.map

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var constants_1 = __webpack_require__(755);
var processPurchase = function (purchase) {
    if (!purchase) {
        return purchase;
    }
    if (Array.isArray(purchase)) {
        purchase.forEach(processPurchase);
        return purchase;
    }
    return Object.assign(purchase, {
        need_rating: ratingNeeded(purchase),
        status: status(purchase),
    });
};
var status = function (purchase) {
    if (purchase["refunded_at"]) {
        return "refunded";
    }
    if (purchase["finished_at"]) {
        return "finished";
    }
    if (purchase["accepted_at"]) {
        return "accepted";
    }
    return "pending";
};
var all = function (scope, page) {
    if (page === void 0) { page = 1; }
    return Request.sendGet(constants_1.endpoints.api + "/" + scope + "_purchases", {
        page: page,
    })
        .then(processPurchase);
};
exports.all = all;
var get = function (id) {
    return Request.sendGet(constants_1.endpoints.api + "/purchases/" + id)
        .then(processPurchase);
};
exports.get = get;
var create = function (offer, expert) {
    if (expert === void 0) { expert = null; }
    var data = {
        offer_id: offer["id"],
    };
    if (expert) {
        data["admin_id"] = expert["id"];
    }
    return Request.sendPost(constants_1.endpoints.api + "/purchases", data)
        .then(processPurchase);
};
exports.create = create;
var save = function (purchase, data) {
    var serviceType = purchase["offer"]["service_type"];
    return Request.sendPut(constants_1.endpoints.api + "/" + serviceType + "_services/" + purchase["id"], data)
        .then(processPurchase);
};
exports.save = save;
var pay = function (purchase) {
    return Request.sendPost(constants_1.endpoints.api + "/purchase_payments", {
        purchase_id: purchase["id"],
        card_id: purchase["card_id"],
    })
        .then(processPurchase);
};
exports.pay = pay;
var canAccept = function (purchase) {
    if (purchase["accepted_at"]) {
        return false;
    }
    if (purchase["refunded_at"]) {
        return false;
    }
    return purchase["service"]["creator_type"] === "Admin";
};
exports.canAccept = canAccept;
var accept = function (purchase) {
    if (!canAccept(purchase)) {
        throw "Cannot accept purchase " + purchase["id"];
    }
    return Request.sendPost(constants_1.endpoints.api + "/accept_purchases", {
        purchase_id: purchase["id"],
    })
        .then(processPurchase);
};
exports.accept = accept;
var canRefund = function (purchase) {
    if (purchase["service_type"] === "call") {
        return false;
    }
    if (!!purchase["refunded_at"]) {
        return false;
    }
    if (!purchase["payed_at"]) {
        return false;
    }
    if (!!purchase["finished_at"]) {
        return false;
    }
    return true;
};
exports.canRefund = canRefund;
var refund = function (purchase) {
    if (!canRefund(purchase)) {
        throw "Cannot refund purchase " + purchase["id"];
    }
    return Request.sendPost(constants_1.endpoints.api + "/refunds", {
        purchase_id: purchase["id"],
    })
        .then(processPurchase);
};
exports.refund = refund;
var toReview = function () {
    return Request.sendGet(constants_1.endpoints.api + "/waiting_for_review_purchases")
        .then(processPurchase);
};
exports.toReview = toReview;
var ratingNeeded = function (purchase) {
    if (!purchase["finished_at"]) {
        return false;
    }
    if (purchase["rating"]) {
        return false;
    }
    if (purchase["refunded_at"]) {
        return false;
    }
    if (purchase["offer"]["service_type"] === "prepaid_minute") {
        return false;
    }
    if (purchase["offer"]["service_type"] === "phone") {
        return purchase["service"]["call"]["status"] === "completed";
    }
    return true;
};
exports.ratingNeeded = ratingNeeded;
//# sourceMappingURL=purchase.js.map

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var User = __webpack_require__(877);
var constants_1 = __webpack_require__(755);
var all = function (page, expertId) {
    if (page === void 0) { page = 1; }
    if (expertId === void 0) { expertId = null; }
    var endpoint = expertId ? constants_1.endpoints.api + "/experts/" + expertId + "/ratings" : constants_1.endpoints.api + "/ratings";
    return Request.sendGet(endpoint, {
        page: page,
    });
};
exports.all = all;
var create = function (purchase, note, content) {
    if (content === void 0) { content = null; }
    return Request.sendPost(constants_1.endpoints.api + "/ratings", {
        note: note,
        purchase_id: purchase,
        content: content,
    })
        .then(function (rating) {
        User.current({ forceFetch: true });
        return rating;
    });
};
exports.create = create;
//# sourceMappingURL=rating.js.map

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var constants_1 = __webpack_require__(755);
var message = function (data) {
    return Request.sendPost(constants_1.endpoints.api + "/supports", data);
};
exports.message = message;
//# sourceMappingURL=support.js.map

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Request = __webpack_require__(762);
var Platform = __webpack_require__(857);
var constants_1 = __webpack_require__(755);
var getUploadUrl = function (platform, file, path) {
    var fullPath = [
        "platforms",
        platform.id,
        path,
    ].filter(function (e) { return e; }).join("/");
    return Request.sendPost(constants_1.endpoints.upload, {
        path: fullPath,
        file_name: file ? parameterize(file.name) : null,
        file_type: file ? encodeURIComponent(file.type) : null,
    });
};
var uploadToUrl = function (data, file) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', data['signed_request']);
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                return;
            }
            if (xhr.status !== 200) {
                reject();
            }
            resolve({
                url: data['url'],
                name: file.name,
                type: file.type,
            });
        };
        xhr.send(file);
    });
};
var resize = function (path) {
    return Request.sendPost(constants_1.endpoints.upload + "/resize", {
        key: path,
    });
};
var parameterize = function (value) {
    var transformation = value.toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    return encodeURIComponent(transformation);
};
var upload = function (file, path) {
    return Platform.current()
        .then(function (platform) {
        return getUploadUrl(platform, file, path)
            .then(function (data) { return uploadToUrl(data, file); })
            .then(function (data) { return resize(data.url); });
    });
};
exports.upload = upload;
//# sourceMappingURL=upload.js.map

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(915);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("58750cfc", content, true);

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, "thead[data-v-5f51f861]{border-bottom:1px solid rgba(0,0,0,.12)}.cell[data-v-5f51f861]{text-align:center!important;width:50px;min-width:50px;max-width:50px;padding:0!important}.expert[data-v-5f51f861]{text-align:left;width:150px;min-width:150px;max-width:150px}.result[data-v-5f51f861]{text-align:right;width:110px;min-width:110px;max-width:110px}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/availabilities/ExpertsPerDay.vue"],"names":[],"mappings":"AACA,uBACE,uCAA0C,CAC3C,AACD,uBACE,4BAA8B,AAC9B,WAAY,AACZ,eAAgB,AAChB,eAAgB,AAChB,mBAAsB,CACvB,AACD,yBACE,gBAAiB,AACjB,YAAa,AACb,gBAAiB,AACjB,eAAiB,CAClB,AACD,yBACE,iBAAkB,AAClB,YAAa,AACb,gBAAiB,AACjB,eAAiB,CAClB","file":"ExpertsPerDay.vue","sourcesContent":["\nthead[data-v-5f51f861] {\n  border-bottom: 1px solid rgba(0,0,0,0.12);\n}\n.cell[data-v-5f51f861] {\n  text-align: center !important;\n  width: 50px;\n  min-width: 50px;\n  max-width: 50px;\n  padding: 0 !important;\n}\n.expert[data-v-5f51f861] {\n  text-align: left;\n  width: 150px;\n  min-width: 150px;\n  max-width: 150px;\n}\n.result[data-v-5f51f861] {\n  text-align: right;\n  width: 110px;\n  min-width: 110px;\n  max-width: 110px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(917);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("6f3b9b32", content, true);

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, "td[data-v-c805ff82]{border:1px solid rgba(0,0,0,.12);padding:0;position:relative}td:hover .card[data-v-c805ff82],td:hover span[data-v-c805ff82]{opacity:1}td .card[data-v-c805ff82],td span[data-v-c805ff82]{-webkit-transition:all .3s;transition:all .3s;opacity:0}td .card[data-v-c805ff82]{position:absolute;bottom:0;left:0}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/availabilities/AvailabilityCell.vue"],"names":[],"mappings":"AACA,oBACE,iCAAmC,AACnC,UAAW,AACX,iBAAmB,CACpB,AACD,+DAEE,SAAW,CACZ,AACD,mDAEE,2BAA8B,AAC9B,mBAAsB,AACtB,SAAW,CACZ,AACD,0BACE,kBAAmB,AACnB,SAAU,AACV,MAAQ,CACT","file":"AvailabilityCell.vue","sourcesContent":["\ntd[data-v-c805ff82] {\n  border: 1px solid rgba(0,0,0,0.12);\n  padding: 0;\n  position: relative;\n}\ntd:hover span[data-v-c805ff82],\ntd:hover .card[data-v-c805ff82] {\n  opacity: 1;\n}\ntd span[data-v-c805ff82],\ntd .card[data-v-c805ff82] {\n  -webkit-transition: all 300ms;\n  transition: all 300ms;\n  opacity: 0;\n}\ntd .card[data-v-c805ff82] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(919);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("1c3e0482", content, true);

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, "thead[data-v-3cab1f0d]{border-bottom:1px solid rgba(0,0,0,.12)}.slider[data-v-3cab1f0d]{border:1px solid #ccc;background:-webkit-gradient(linear,left top,right top,from(#fff),to(#68b86b));background:linear-gradient(90deg,#fff,#68b86b)}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/availabilities/ExpertsPerWeek.vue"],"names":[],"mappings":"AACA,uBACE,uCAA0C,CAC3C,AACD,yBACE,sBAAuB,AACvB,8EAAmF,AACnF,8CAAqD,CACtD","file":"ExpertsPerWeek.vue","sourcesContent":["\nthead[data-v-3cab1f0d] {\n  border-bottom: 1px solid rgba(0,0,0,0.12);\n}\n.slider[data-v-3cab1f0d] {\n  border: solid 1px #ccc;\n  background: -webkit-gradient(linear, left top, right top, from(#fff), to(#68b86b));\n  background: linear-gradient(to right, #fff, #68b86b);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__(31);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/skiliko-sdk/lib/index.js
var lib = __webpack_require__(868);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/api/availabilities.js




var MILLISEC_IN_HOURS = 1000 * 60 * 60;

var availabilities_perExpert = function perExpert(experts) {
  return experts.map(function (expert) {
    return {
      expert: expert,
      availabilies: lib["Timezone"].scheduleToCurrentDates(expert.schedule, expert.timezone, expert.timezone_offset)
    };
  });
};

var availabilities_hoursPerWeekDay = function hoursPerWeekDay(experts) {
  return availabilities_perExpert(experts).map(function (e) {
    return extends_default()({}, e, {
      hours: [].concat(toConsumableArray_default()(Array(7))).map(function (_, i) {
        return e.availabilies[i].reduce(function (acc, value) {
          acc += +value.to - +value.from;
          return acc;
        }, 0) / MILLISEC_IN_HOURS;
      })
    });
  });
};

var availabilities_totalHoursPerDay = function totalHoursPerDay(experts) {
  return availabilities_hoursPerWeekDay(experts).map(function (e) {
    return e.hours;
  }).reduce(function (acc, value) {
    return value.map(function (e, i) {
      return acc[i] + e;
    });
  }, [0, 0, 0, 0, 0, 0, 0]);
};

var maxHourPerDay = function maxHourPerDay(experts) {
  return availabilities_hoursPerWeekDay(experts).map(function (e) {
    return e.hours.sort(function (a, b) {
      return b - a;
    })[0];
  }).sort(function (a, b) {
    return b - a;
  })[0];
};

/* harmony default export */ var availabilities = ({
  hoursPerWeekDay: availabilities_hoursPerWeekDay,
  maxHourPerDay: maxHourPerDay,
  totalHoursPerDay: availabilities_totalHoursPerDay
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(79);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/availabilities/AvailabilityCell.vue



/* harmony default export */ var AvailabilityCell = ({
  components: {
    Minute: formatters["c" /* Minute */]
  },
  props: {
    availabilities: {
      type: Array,
      required: true
    },
    maxHours: {
      type: Number,
      required: true
    },
    noDetails: {
      type: Boolean,
      default: false
    },
    color: {
      type: Object,
      default: function _default() {
        return {
          r: 104,
          g: 184,
          b: 107
        };
      }
    }
  },
  computed: {
    minutes: function minutes() {
      return this.availabilities.reduce(function (sum, value) {
        return sum + (value.to - value.from) / 1000;
      }, 0);
    }
  },
  methods: {
    colorize: function colorize() {
      var percent = this.minutes / 60 / 60 / this.maxHours;
      return { background: 'rgba(' + this.color.r + ', ' + this.color.g + ', ' + this.color.b + ', ' + percent + ')' };
    },
    scheduleToStr: function scheduleToStr(date) {
      return [('0' + date.getHours()).substr(-2), ('0' + date.getMinutes()).substr(-2)].join(':');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c805ff82","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/AvailabilityCell.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-xs-center",style:(_vm.colorize())},[(!_vm.noDetails)?_c('v-menu',[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_c('minute',{attrs:{"value":_vm.minutes}})],1),_vm._v(" "),_c('v-list',_vm._l((_vm.availabilities),function(availability,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-title',[_vm._v("\n          "+_vm._s(_vm.scheduleToStr(availability.from))+"\n          "),_c('v-icon',[_vm._v("chevron_right")]),_vm._v("\n          "+_vm._s(_vm.scheduleToStr(availability.to))+"\n        ")],1)],1)}),1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var availabilities_AvailabilityCell = (esExports);
// CONCATENATED MODULE: ./src/components/availabilities/AvailabilityCell.vue
function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c805ff82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AvailabilityCell,
  availabilities_AvailabilityCell,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_availabilities_AvailabilityCell = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/availabilities/ExpertsPerDay.vue








/* harmony default export */ var ExpertsPerDay = ({
  components: {
    Minute: formatters["c" /* Minute */],
    AvailabilityCell: components_availabilities_AvailabilityCell
  },
  props: {
    day: {
      type: Number,
      required: true
    },
    experts: {
      type: Array,
      required: true
    },
    smartHours: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    startsAt: function startsAt() {
      return this.smartHours ? this.getMaxValue(function (e) {
        return e.from.getHours();
      }, function (a, b) {
        return a - b;
      }) : 0;
    },
    endsAt: function endsAt() {
      return this.smartHours ? this.getMaxValue(function (e) {
        return e.to.getHours() || 24;
      }, function (a, b) {
        return b - a;
      }) : 24;
    },
    hours: function hours() {
      var shift = this.startsAt;
      var hours = (this.endsAt || 24) - shift;
      return [].concat(toConsumableArray_default()(new Array(hours))).map(function (_, i) {
        return i + shift;
      });
    },
    totalExpertsHour: function totalExpertsHour() {
      var _this = this;

      return this.experts.reduce(function (acc, expert) {
        return extends_default()({}, acc, defineProperty_default()({}, expert.id, _this.expertSchedule(expert).reduce(function (sum, value) {
          return sum + (+value.to - +value.from);
        }, 0) / (1000 * 60 * 60)));
      }, {});
    },
    totalHours: function totalHours() {
      var _this2 = this;

      return this.hours.reduce(function (sum, hour) {
        return _this2.totalHourForHour(hour) + sum;
      }, 0);
    }
  },
  methods: {
    adjustDate: function adjustDate(comparator, date, hour) {
      var newDate = date.getDay() > this.day ? new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, hour) : new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour);
      return new Date(comparator(+date, +newDate));
    },
    availabilitiesOf: function availabilitiesOf(expert, hour) {
      var _this3 = this;

      return this.expertSchedule(expert).filter(function (x) {
        return x.from.getHours() <= hour;
      }).filter(function (x) {
        return (x.to.getHours() || 24) >= hour;
      }).map(function (x) {
        return {
          from: _this3.adjustDate(Math.max, x.from, hour),
          to: _this3.adjustDate(Math.min, x.to, hour + 1)
        };
      });
    },
    totalHourForHour: function totalHourForHour(hour) {
      var _this4 = this;

      return this.experts.map(function (x) {
        return _this4.availabilitiesOf(x, hour).reduce(function (sum, availability) {
          return sum + Math.max(availability.to - availability.from, 0);
        }, 0);
      }).reduce(function (sum, x) {
        return sum + x;
      }, 0);
    },
    expertSchedule: function expertSchedule(expert) {
      return lib["Timezone"].scheduleToCurrentDates(expert.schedule, expert.timezone, expert.timezone_offset)[this.day];
    },
    getMaxValue: function getMaxValue(item, sort) {
      var _this5 = this;

      return this.experts.map(function (expert) {
        return _this5.expertSchedule(expert);
      }).map(function (schedule) {
        return schedule.map(item).sort(sort)[0];
      }).sort(sort)[0];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f51f861","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/ExpertsPerDay.vue
var ExpertsPerDay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('div',{staticClass:"table__overflow"},[_c('table',{staticClass:"datatable table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"expert"},[_vm._v(_vm._s(_vm.$t('availabilities.expertsperday.header.expert')))]),_vm._v(" "),_vm._l((_vm.hours),function(hour){return _c('th',{key:hour,staticClass:"cell"},[_c('minute',{attrs:{"value":hour * 60 * 60,"display-empty":""}})],1)}),_vm._v(" "),_c('th',{staticClass:"result"})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.experts),function(expert){return _c('tr',{key:expert.id},[_c('td',{staticClass:"expert"},[_vm._v("\n            "+_vm._s(expert.nickname)+"\n          ")]),_vm._v(" "),_vm._l((_vm.hours),function(hour){return _c('availability-cell',{key:hour,staticClass:"cell",attrs:{"availabilities":_vm.availabilitiesOf(expert, hour),"maxHours":1}})}),_vm._v(" "),_c('td',{staticClass:"result"},[_c('minute',{attrs:{"value":_vm.totalExpertsHour[expert.id] * 60 * 60,"display-empty":""}})],1)],2)}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{staticClass:"expert"}),_vm._v(" "),_vm._l((_vm.hours),function(hour){return _c('td',{key:hour,staticClass:"cell"},[_c('minute',{attrs:{"value":_vm.totalHourForHour(hour) / 1000,"display-empty":""}})],1)}),_vm._v(" "),_c('td',{staticClass:"result pr-3"},[_c('minute',{attrs:{"value":_vm.totalHours / 1000,"display-empty":""}})],1)],2)])])])])}
var ExpertsPerDay_staticRenderFns = []
var ExpertsPerDay_esExports = { render: ExpertsPerDay_render, staticRenderFns: ExpertsPerDay_staticRenderFns }
/* harmony default export */ var availabilities_ExpertsPerDay = (ExpertsPerDay_esExports);
// CONCATENATED MODULE: ./src/components/availabilities/ExpertsPerDay.vue
function ExpertsPerDay_injectStyle (ssrContext) {
  __webpack_require__(914)
}
var ExpertsPerDay_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ExpertsPerDay___vue_template_functional__ = false
/* styles */
var ExpertsPerDay___vue_styles__ = ExpertsPerDay_injectStyle
/* scopeId */
var ExpertsPerDay___vue_scopeId__ = "data-v-5f51f861"
/* moduleIdentifier (server only) */
var ExpertsPerDay___vue_module_identifier__ = null
var ExpertsPerDay_Component = ExpertsPerDay_normalizeComponent(
  ExpertsPerDay,
  availabilities_ExpertsPerDay,
  ExpertsPerDay___vue_template_functional__,
  ExpertsPerDay___vue_styles__,
  ExpertsPerDay___vue_scopeId__,
  ExpertsPerDay___vue_module_identifier__
)

/* harmony default export */ var components_availabilities_ExpertsPerDay = (ExpertsPerDay_Component.exports);

// CONCATENATED MODULE: ./src/mixins/availabilitiesTable.js


/* harmony default export */ var availabilitiesTable = ({
  props: {
    experts: {
      type: Array,
      required: true
    }
  },
  computed: {
    hoursPerDay: function hoursPerDay() {},
    hoursPerWeekDay: function hoursPerWeekDay() {
      return availabilities.hoursPerWeekDay(this.experts);
    },
    maxHours: function maxHours() {
      return availabilities.maxHourPerDay(this.experts);
    },
    totalHoursPerDay: function totalHoursPerDay() {
      return availabilities.totalHoursPerDay(this.experts);
    }
  },
  methods: {
    sumHours: function sumHours(hours) {
      return hours.reduce(function (sum, hour) {
        return sum + hour;
      }, 0);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/availabilities/ExpertsPerWeek.vue





/* harmony default export */ var ExpertsPerWeek = ({
  components: {
    Minute: formatters["c" /* Minute */],
    AvailabilityCell: components_availabilities_AvailabilityCell
  },
  mixins: [availabilitiesTable],
  computed: {
    days: function days() {
      return new Array(7);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cab1f0d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/ExpertsPerWeek.vue
var ExpertsPerWeek_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('div',{staticClass:"table__overflow"},[_c('table',{staticClass:"datatable table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-xs-left",attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('availabilities.expertsperweek.header.expert')))]),_vm._v(" "),_vm._l((_vm.days),function(day,i){return _c('th',{key:i,staticClass:"text-xs-center",attrs:{"width":"10%"}},[_vm._v("\n            "+_vm._s(_vm.$t(("availabilities.expertsperweek.header.day." + i)))+"\n          ")])}),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.hoursPerWeekDay),function(availability){return _c('tr',{key:availability.id},[_c('td',{staticClass:"text-xs-left"},[_vm._v("\n            "+_vm._s(availability.expert.nickname)+"\n          ")]),_vm._v(" "),_vm._l((availability.hours),function(hour,index){return _c('availability-cell',{key:index,attrs:{"availabilities":availability.availabilies[index],"maxHours":_vm.maxHours}})}),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('minute',{attrs:{"value":_vm.sumHours(availability.hours) * 60 * 60,"display-empty":""}})],1)],2)}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td'),_vm._v(" "),_vm._l((_vm.days),function(day,i){return _c('td',{key:i,staticClass:"text-xs-center"},[_c('minute',{attrs:{"value":_vm.totalHoursPerDay[i] * 60 * 60,"display-empty":""}})],1)}),_vm._v(" "),_c('td',{staticClass:"text-xs-right pr-3"},[_c('minute',{attrs:{"value":_vm.sumHours(_vm.totalHoursPerDay) * 60 * 60,"display-empty":""}})],1)],2)])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs4":"","md3":""}},[_vm._v(_vm._s(_vm.$t('availabilities.expertsperweek.notAvailable')))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center slider",attrs:{"xs4":"","md6":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs4":"","md3":""}},[_vm._v(_vm._s(_vm.$t('availabilities.expertsperweek.available', { maxHour: _vm.maxHours })))])],1)],1)],1)}
var ExpertsPerWeek_staticRenderFns = []
var ExpertsPerWeek_esExports = { render: ExpertsPerWeek_render, staticRenderFns: ExpertsPerWeek_staticRenderFns }
/* harmony default export */ var availabilities_ExpertsPerWeek = (ExpertsPerWeek_esExports);
// CONCATENATED MODULE: ./src/components/availabilities/ExpertsPerWeek.vue
function ExpertsPerWeek_injectStyle (ssrContext) {
  __webpack_require__(918)
}
var ExpertsPerWeek_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ExpertsPerWeek___vue_template_functional__ = false
/* styles */
var ExpertsPerWeek___vue_styles__ = ExpertsPerWeek_injectStyle
/* scopeId */
var ExpertsPerWeek___vue_scopeId__ = "data-v-3cab1f0d"
/* moduleIdentifier (server only) */
var ExpertsPerWeek___vue_module_identifier__ = null
var ExpertsPerWeek_Component = ExpertsPerWeek_normalizeComponent(
  ExpertsPerWeek,
  availabilities_ExpertsPerWeek,
  ExpertsPerWeek___vue_template_functional__,
  ExpertsPerWeek___vue_styles__,
  ExpertsPerWeek___vue_scopeId__,
  ExpertsPerWeek___vue_module_identifier__
)

/* harmony default export */ var components_availabilities_ExpertsPerWeek = (ExpertsPerWeek_Component.exports);

// EXTERNAL MODULE: ./src/components/Stat.vue + 2 modules
var Stat = __webpack_require__(751);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/TeamAvailabilities.vue










/* harmony default export */ var TeamAvailabilities = ({
  components: {
    Stat: Stat["a" /* default */],
    Minute: formatters["c" /* Minute */],
    AvailabilityExpertsPerWeek: components_availabilities_ExpertsPerWeek,
    AvailabilityExpertsPerDay: components_availabilities_ExpertsPerDay
  },
  props: {
    interval: {
      type: String,
      default: 'week'
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    expertsMap: 'skiliko/experts/collection',
    loading: 'skiliko/experts/isLoading'
  }), {
    previousDay: function previousDay() {
      return (parseInt(this.interval, 10) - 1 + 7) % 7;
    },
    nextDay: function nextDay() {
      return (parseInt(this.interval, 10) + 1) % 7;
    },
    expertIds: function expertIds() {
      return keys_default()(this.expertsMap);
    },
    experts: function experts() {
      var _this = this;

      return this.expertIds.map(function (id) {
        return _this.expertsMap[id];
      }).filter(function (e) {
        return ['restricted', 'active'].indexOf(e.role) >= 0;
      }).sort(function (a, b) {
        return a.priority - b.priority;
      });
    },
    totalHoursPerDay: function totalHoursPerDay() {
      return availabilities.totalHoursPerDay(this.experts);
    },
    todayHoursToday: function todayHoursToday() {
      return this.totalHoursPerDay[new Date().getDay()];
    },
    averageHours: function averageHours() {
      return (this.totalHoursPerDay.reduce(function (sum, hour) {
        return sum + hour;
      }, 0) / this.expertIds.length).toFixed(2);
    },
    maxHours: function maxHours() {
      return availabilities.maxHourPerDay(this.experts);
    },
    days: function days() {
      return new Array(7);
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetchAvailabilities: 'skiliko/experts/availabilities'
  }), {
    setTimeInterval: function setTimeInterval(interval) {
      this.$router.replace(extends_default()({}, this.$route, {
        query: { interval: interval.toString() }
      }));
    }
  }),
  mounted: function mounted() {
    this.fetchAvailabilities();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f6d52b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeamAvailabilities.vue
var TeamAvailabilities_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('pages.teamavailabilities.title')))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"","md4":""}},[_c('stat',{attrs:{"title":_vm.$t('pages.teamavailabilities.today')}},[_c('minute',{attrs:{"value":_vm.todayHoursToday * 60 * 60}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"","md4":""}},[_c('stat',{attrs:{"title":_vm.$t('pages.teamavailabilities.average')}},[_c('minute',{attrs:{"value":_vm.averageHours * 60 * 60,"ignore-seconds":""}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"","md4":""}},[_c('stat',{attrs:{"title":_vm.$t('pages.teamavailabilities.max')}},[_c('minute',{attrs:{"value":_vm.maxHours * 60 * 60}})],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-toolbar',{staticClass:"transparent elevation-0"},[(_vm.interval === 'week')?_c('v-toolbar-title',{staticClass:"hidden-sm-and-down"},[_vm._v("\n        "+_vm._s(_vm.$t('pages.teamavailabilities.perWeek'))+"\n      ")]):_c('v-toolbar-title',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.setTimeInterval(_vm.previousDay)}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_vm._v("\n        "+_vm._s(_vm.$t(("pages.teamavailabilities.days." + _vm.interval)))+"\n        "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.setTimeInterval(_vm.nextDay)}}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","primary":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.setTimeInterval('week')}}},[_vm._v(_vm._s(_vm.$t('pages.teamavailabilities.perWeek')))]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","primary":""},slot:"activator"},[_vm._v("\n          "+_vm._s(_vm.$t('pages.teamavailabilities.perDay'))+"\n          "),_c('v-icon',{staticClass:"primary--text"},[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.days),function(day,i){return _c('v-list-item',{key:day},[_c('v-list-tile',{nativeOn:{"click":function($event){return _vm.setTimeInterval(i)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(("pages.teamavailabilities.days." + i))))])],1)],1)}),1)],1)],1),_vm._v(" "),(_vm.experts)?_c('div',[(_vm.interval === 'week')?_c('availability-experts-per-week',{attrs:{"experts":_vm.experts}}):_c('availability-experts-per-day',{attrs:{"day":parseInt(_vm.interval, 10),"experts":_vm.experts}})],1):_vm._e()],1)],1)}
var TeamAvailabilities_staticRenderFns = []
var TeamAvailabilities_esExports = { render: TeamAvailabilities_render, staticRenderFns: TeamAvailabilities_staticRenderFns }
/* harmony default export */ var pages_TeamAvailabilities = (TeamAvailabilities_esExports);
// CONCATENATED MODULE: ./src/pages/TeamAvailabilities.vue
var TeamAvailabilities_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var TeamAvailabilities___vue_template_functional__ = false
/* styles */
var TeamAvailabilities___vue_styles__ = null
/* scopeId */
var TeamAvailabilities___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TeamAvailabilities___vue_module_identifier__ = null
var TeamAvailabilities_Component = TeamAvailabilities_normalizeComponent(
  TeamAvailabilities,
  pages_TeamAvailabilities,
  TeamAvailabilities___vue_template_functional__,
  TeamAvailabilities___vue_styles__,
  TeamAvailabilities___vue_scopeId__,
  TeamAvailabilities___vue_module_identifier__
)

/* harmony default export */ var src_pages_TeamAvailabilities = __webpack_exports__["default"] = (TeamAvailabilities_Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.734112c03792cce02f3d.js